import { useEffect } from 'react';
import './App.scss';
import ApiIntegration from './view/api-integration';
import Login from './view/login';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {LOCALSTORAGE_KEYS, ENVIROMENT} from './utils/enum'
import { getLocalStorageItemHandler, setLocalStorageItemHandler } from "./service/local-storage";
import { websiteTrackingApi } from "./service/axios/login.axios";
import ErrorBoundary from './view/ErrorBoundary';
function App() {
  const { USER_TRACK } = LOCALSTORAGE_KEYS
// tracking user activity
  useEffect(() => {
    // getting date and time of visit
    if (process.env.REACT_APP_NODE_ENV === ENVIROMENT.PRODUCTION){
      try{
    const urlParams = new URLSearchParams(window.location.search);
    const userTrackingDetails = urlParams.get('userTrackingDetails') && JSON.parse(urlParams.get('userTrackingDetails'));
    let today = new Date();
    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    let dateTime = date + ' ' + time;
    let timeZone = today && today.toString() && today.toString().split('GMT') && today.toString().split('GMT')[1] && typeof(today.toString().split('GMT')[1]) === 'string' ? 'GMT ' + today.toString().split('GMT')[1] : ''
    
    if (getLocalStorageItemHandler(USER_TRACK) && getLocalStorageItemHandler(USER_TRACK).emailId) {
        let obj = {
          email_address: getLocalStorageItemHandler(USER_TRACK).emailId,
          userActivityDetails: [{ url: window.location.href, time: dateTime, time_zone: timeZone }]
        }
        websiteTrackingApi(obj)
        .catch(err=>console.log(err))
        // API call -- if emailId is already present in the system -- sending current URL to server
      } else if (userTrackingDetails){
        let obj = getLocalStorageItemHandler(USER_TRACK) || {}
        if (userTrackingDetails.userId) obj.userId = userTrackingDetails.userId
        if (userTrackingDetails.emailId) obj.emailId = userTrackingDetails.emailId
        if (userTrackingDetails.path) obj.path = [...userTrackingDetails.path, { url: window.location.href, time: dateTime, time_zone: timeZone }]
        setLocalStorageItemHandler(USER_TRACK, JSON.stringify(obj))
      } 
    }
    catch(err){
      console.log(err)
    }
  }
  })
  return (
    <div className="App">
      <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/api-exploration" element={<ApiIntegration />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={<Navigate to="/login" replace />}
          />
        </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;
